/**
 *  [2022] Zettant Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Zettant Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Zettant Incorporated and its
 * suppliers and may be covered by Japan. and Foreign Patents,
 * patents in process, and are protected by trade secret or
 * copyright law. Dissemination of this information or
 * reproduction of this material is strictly forbidden unless
 * prior written permission is obtained from Zettant Incorporated.
 */

/**
 * :ZNOTE:
 * tag: logout,ログアウト
 * note:
 *  - ログアウト機能の実体
 * sample:
 *  - src/awsCodes/awsLogout.ts
 * :ZNOTE:
 */

import {getUserIdFromToken} from '@zettant/commonUtils';
import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js';
import {clearAuthInfo, getAuthInfo, getPoolData, returnCodes} from './awsUtils';

const _simpleLogout = async (reason?: string) => {
  reason;
  const authInfo: any = await getAuthInfo(false);
  if (authInfo.username === '') {
    return {
      success: true,
      code: returnCodes.http.success.code,
      message: 'OK',
      result: true
    };
  }

  const userName = getUserIdFromToken(authInfo.idToken);
  const userPool = new AmazonCognitoIdentity.CognitoUserPool(getPoolData());
  const userData = {
    Username: userName,
    Pool: userPool
  };
  // @ts-ignore
  const cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
  cognitoUser.signOut();
  clearAuthInfo();
  return {
    success: true,
    code: returnCodes.http.success.code,
    message: 'OK',
    result: true
  };
};

let doLogout: (reason?: string) => void = _simpleLogout;
let loggingOut = false;
const resetLoggingOutFlag = () => loggingOut = false;

const setLogoutFunc = (func: any) => doLogout = func;

const awsLogout = async (reason?: string) => {
  if (loggingOut) return;
  loggingOut = true;
  await doLogout(reason);
};

export {setLogoutFunc, awsLogout, resetLoggingOutFlag};
